<div class="k-d-flex k-justify-content-between k-gap-md">
  <kendo-chip themeColor="success" (click)="navigateToReport()">
    <span class="custom-content">
      <span *ngIf="alerts">
        {{ alerts.scheduledChangesCount }} scheduled change(s)
      </span>
      <kendo-loader
        size="small"
        themeColor="success"
        *ngIf="!alerts"
      ></kendo-loader>
    </span>
  </kendo-chip>

  <!-- Hide LTO alerts for AvailabilityOnly users (LTOs are pricing-related) -->
  <kendo-chip
    *ngIf="(alerts?.newLtoCount ?? 0) > 0 && !isAvailabilityOnly"
    themeColor="success"
    (click)="navigateToLtos()"
  >
    <span class="custom-content">
      <span *ngIf="alerts"> {{ alerts.newLtoCount }} new LTO item(s) </span>
    </span>
  </kendo-chip>
</div>

<kendo-dialog
  [width]="700"
  *ngIf="ltoPopupVisible"
  (close)="ltoPopupVisible = false"
>
  <kendo-dialog-titlebar>
    <span>{{ alerts?.newLtoCount }} New LTO Item(s) Available</span>
  </kendo-dialog-titlebar>
  <ul [style.maxHeight.px]="500">
    <li *ngFor="let lto of newLtos.data">
      <div class="k-font-size-md">
        {{ lto.itemName }} ({{ lto.parItemId }})
        <ul *ngFor="let documentPath of lto.documentPath">
          <li
            class="k-d-flex k-gap-md"
            (click)="downloadDocument(lto, documentPath)"
          >
            <a href="javascript:void(0)">
              <fa-icon
                class="k-cursor-pointer"
                kendoTooltip
                title="Download document"
                *ngIf="documentPath"
                [icon]="['fas', 'paperclip']"
              ></fa-icon>
              {{ documentPath }}
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>
  <kendo-dialog-actions layout="center">
    <p class="k-font-size-lg">Do you want to manage these new items now?</p>
    <button kendoButton (click)="ltoPopupVisible = false">No</button>
    <button
      kendoButton
      (click)="navigateToLtos(); ltoPopupVisible = false"
      themeColor="success"
    >
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  [width]="700"
  *ngIf="acknowledgementVisible"
  (close)="acknowledgementVisible = false"
>
  <kendo-dialog-titlebar>
    <span>New LTO item(s) review complete</span>
  </kendo-dialog-titlebar>

  <p class="k-font-size-lg">
    If you continue, you will no longer be alerted for these item(s).
  </p>

  <ul class="k-font-size-lg">
    <li>
      They’ll remain available in <strong>Product Pricing</strong> under the
      <strong>LTO</strong> category.
    </li>
    <li>You won’t see this alert again until new LTO items are added.</li>
  </ul>
  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="acknowledgementVisible = false">
      No, keep reminding me
    </button>
    <button
      kendoButton
      (click)="acknowledgeLtos(); acknowledgementVisible = false"
      themeColor="success"
    >
      Yes, I am done
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
